import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const GetFeaturedProductsQuery = gql`
  query($tags: [String!]!, $orderBy: String, $orderDirection: String, $limit: Int, $country: String, $customerId: String) {
    similarProducts(tags: $tags, orderBy: $orderBy, orderDirection: $orderDirection, limit: $limit, country: $country, customerId: $customerId) {
      id
      title
      name
      slug
      price
      prices
      recommendedPrice
      tags
      description
      sku
      display
      status
      weight
      weightForShipping
      hideForCountry
      neverApplyCustomerDiscounts
      customerGroupsOnlyDiscountIds
      visibleForCustomerGroup
      images {
        id
        file
        priority
      }
      availability {
        id
        name
        title
        color
        watchDogAction
      }
      variants {
        id
        sku
        ean
        definition
        price
        recommendedPrice
        prices
        inStock
      }
      manufacturer {
        id
        name
      }
    }
  }
`;

interface IInputProps {
  children?: any;
  tags: Array<string>;
  orderBy?: string;
  orderDirection?: string;
  limit?: number;
  country?: string;
  loggedCustomer?: string;
}

interface IResponse {
  data: any;
}

class FeaturedProductsQuery extends React.PureComponent<ChildProps<IInputProps, IResponse>> {
  public render() {
    const products = (this.props as any).products;
    return this.props.children({
      products
    });
  }
}

export default compose(
  graphql<IInputProps, IResponse>(GetFeaturedProductsQuery, {
    name: 'products',
    options: props => ({
      variables: {
        tags: props.tags,
        orderBy: props.orderBy,
        orderDirection: props.orderDirection,
        limit: props.limit,
        country: props.country,
        // userId tady je, aby se vynutilo znovunačtení query místo načtení odpovědi z cache a tím aby
        // se přihlášeným uživatelům zobrazovaly i produkty, které se zobrazují pouze skupinám,
        // jinak se nepoužívá
        customerId: props.loggedCustomer,
      }
    })
  })
)(FeaturedProductsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Products/FeaturedProducts.tsx